import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { axiosInstance as axios } from '../../../context/AuthContext';

const US_CENTER = [37.8, -96];

function RequestPopup({ p }) {
  return (
    <div className="text-sm">
      <p className="font-bold">{p.city}{p.region ? `, ${p.region}` : ''}</p>
      <p>{p.count} famil{p.count === 1 ? 'y' : 'ies'} waiting{p.urgent ? ` · ${p.urgent} urgent` : ''}</p>
      <ul className="mt-1">
        {Object.entries(p.specialties).map(([label, n]) => <li key={label}>{label}: {n}</li>)}
      </ul>
    </div>
  );
}

export function RequestsMap({ refreshKey }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get('/api/professional-requests/admin/map').then(r => setData(r.data)).catch(() => setData({ requests: [], professionals: [] }));
  }, [refreshKey]);

  if (!data) return <p className="text-slate-400" data-testid="requests-map-loading">Placing requests on the map…</p>;
  const reqPts = data.requests.filter(p => p.lat != null);
  const proPts = data.professionals.filter(p => p.lat != null);
  const unplaced = data.requests.filter(p => p.lat == null);

  return (
    <div className="space-y-2" data-testid="requests-map">
      <div className="flex flex-wrap gap-4 text-xs text-slate-300">
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-full bg-red-500 inline-block" />Families waiting (bigger = more)</span>
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-full bg-emerald-500 inline-block" />Approved professionals</span>
      </div>
      <div className="rounded-xl overflow-hidden border border-slate-700 h-[420px]">
        <MapContainer center={US_CENTER} zoom={4} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
          <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {proPts.map(p => (
            <CircleMarker key={p.profile_id} center={[p.lat, p.lng]} radius={7} pathOptions={{ color: '#10b981', fillOpacity: 0.8 }}>
              <Tooltip>{p.name} · {p.location}</Tooltip>
            </CircleMarker>
          ))}
          {reqPts.map(p => (
            <CircleMarker key={`${p.city}-${p.region}`} center={[p.lat, p.lng]} radius={8 + Math.min(p.count, 10) * 2}
              pathOptions={{ color: '#ef4444', fillOpacity: 0.5 }}>
              <Popup><RequestPopup p={p} /></Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
      {data.requests.length === 0 && <p className="text-slate-400 text-sm" data-testid="requests-map-empty">No families are waiting right now.</p>}
      {unplaced.length > 0 && (
        <p className="text-amber-300 text-xs" data-testid="requests-map-unplaced">
          Couldn't place on map: {unplaced.map(p => p.city).join(', ')}
        </p>
      )}
    </div>
  );
}
